import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import { AuthProvider, useAuthDispatch} from './AuthContext';
import AppWithMsal from "./AppWithMsals";

 
//export { useAuthDispatch};

if (process.env.NODE_ENV === 'production' && window.location.protocol !== 'https:') {
  window.location.replace(`https://${window.location.host}${window.location.pathname}`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWithMsal />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
